import { useSelector } from "react-redux";
import { useRenderer } from "./useRenderer";

export const useMicroContent = ({
    defaultContent,
    defaultTitleText,
    microContent,
}) => {
    const mode = useSelector((state) => state.root.mode);
    const { getEntityMarkup } = useRenderer();
    const { label, ...rest } = microContent || {};
    const content = rest?.blocks ? rest : defaultContent;
    const title = label ? label : defaultTitleText;

    return {
        content,
        title,
        isEditMode: mode === "edit",
        getEntityMarkup,
    };
};
